import React from 'react';

import {Props} from './model';
import {View} from 'react-native';
import {useStyles} from '../../../../../shared/hooks/styles';
import {HolderAvatar} from '../../../../../shared/components/holderAvatar';
import {Text} from '../../../../../shared/components/text';

export default (props: Props) => {
  const {name, testID} = props;
  const styles = useStyles(({theme}) => {
    return {
      action: {
        ...theme.fonts.h6,
        textAlign: 'center',
      },
      container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.color.primaryNonGreyBackground,
        paddingTop: 24,
        paddingHorizontal: 16,
        paddingBottom: 16,
      },
      image: {marginBottom: 20},
    };
  });
  return (
    <View testID={testID} style={styles.container}>
      <HolderAvatar style={styles.image} size={100} />
      <Text style={styles.action}>{name}</Text>
    </View>
  );
};
